import React, { useEffect, useState } from 'react';
import styles from './TenantDocumentList.module.scss';
import { Button, Modal } from 'antd';
import { capitalizeFirstLetter } from '../../../../../../../Calendar/utils/capitalizeFirstLetter';
import useClientDocuments from '../../../../../../queries/useClientDocuments';
import Documents from '../../../../Documents/Documents';
import { getBlobUrl } from '../../../../../../../../helpers/getBlobUrl';
import getClientDocument from '../../../../../../../../requests/getClientDocument';
import deleteClientDocument from '../../../../../../requests/deleteClientDocument';
import { useQueryClient } from 'react-query';
import { getQueryKeys } from '../../../../../../queries/queryKeys';
import useChangeModalVisible from '../../../../../../../../hooks/useChangeModalVisible';
import { TenantAttachmentsNamesModal } from '../TenantAttachmentsNamesNode/TenantPassportAttachmentsModal';
import { TenantPassportDataModal } from '../TenantPassportDataModal/TenantPassportDataModal';
import cn from 'classnames';

export const TenantDocumentList = ({
  visible,
  documentTypes = [],
  clientId,
}) => {
  const [clientDocumentsList, setClientDocumentsList] = useState([]);

  const {
    visible: TenantAttachmentsNames,
    showModal: showTenantAttachmentsNames,
    hideModal: hideTenantAttachmentsNames,
  } = useChangeModalVisible();

  const {
    visible: TenantPassportDataVisible,
    showModal: showTenantPassportData,
    hideModal: hideTenantPassportData,
  } = useChangeModalVisible();

  const [currentType, setCurrentType] = useState('');

  const handleChooseType = (type) => {
    setCurrentType({
      name: capitalizeFirstLetter(type.name),
      id: type.id,
      attachments: clientDocumentsList.filter(
        (item) => item.documentType.id === type.id
      ),
      subTypes: type.subTypes,
    });
    showTenantAttachmentsNames();
  };

  const queryClient = useQueryClient();

  const handleDeleteDocument = (data) => {
    const fileName = typeof data === 'object' ? data.fileName : data;
    const documentId = typeof data === 'object' ? data.id : data;

    Modal.confirm({
      title: 'Вы уверены, что хотите удалить этот документ?',
      content: 'Файл будет удалён без возможности восстановления',
      okText: 'Да',
      okType: 'danger',
      cancelText: 'Нет',
      onOk: async () => {
        try {
          await deleteClientDocument({
            clientId,
            documentId,
            fileName,
          });

          queryClient.invalidateQueries(getQueryKeys.clientDocuments(clientId));
        } catch (error) {
          console.log(error);
        }
      },
    });
  };

  const { data: clientDocuments, isFetching: isClientDocumentsFetching } =
    useClientDocuments(clientId, {
      enable: visible,
      staleTime: 60 * 5 * 1000,
    });

  const getAttachmentUrl = async (data) => {
    const fileName = typeof data === 'object' ? data.fileName : data;

    const fileExtension = fileName.split('.')[1];

    const attachment = await getClientDocument(clientId, fileName);

    const url = getBlobUrl(attachment, fileExtension);

    return url;
  };

  useEffect(() => {
    if (clientDocuments) {
      setClientDocumentsList(clientDocuments);
    }
  }, [clientDocuments]);

  const handleOpenPassportDataModal = () => {
    showTenantPassportData((prev) => !prev);
  };

  return (
    <div>
      {!!documentTypes.length ? (
        <ul className={styles.documentTypes}>
          {documentTypes.map((type) => (
            <li
              key={type.id}
              className={styles.typeItem}
            >
              {capitalizeFirstLetter(type.name) === 'Паспорт' && (
                <Button
                  className={cn(styles.resetBtn)}
                  onClick={handleOpenPassportDataModal}
                >
                  Паспортные данные
                </Button>
              )}
              <div className={styles.typeNameWrapper}>
                <div className={styles.typeNameWrapperContainer}>
                  <span className={styles.typeName}>
                    {capitalizeFirstLetter(type.name)}
                  </span>
                </div>
                <Button
                  onClick={() => handleChooseType(type)}
                  shape="circle"
                  icon="file-add"
                />
              </div>
              <div className={styles.relatedDocuments}>
                <Documents
                  className={styles.documentsContainer}
                  getAttachmentUrl={getAttachmentUrl}
                  loading={isClientDocumentsFetching}
                  onDeleteDocument={handleDeleteDocument}
                  docs={clientDocumentsList.filter(
                    (doc) => doc.documentType.id === type.id
                  )}
                  showPaginationOnBottom
                />
              </div>
            </li>
          ))}
        </ul>
      ) : (
        <div className={styles.noData}>Нет данных</div>
      )}
      <TenantAttachmentsNamesModal
        clientId={clientId}
        type={currentType}
        onCancel={hideTenantAttachmentsNames}
        visible={TenantAttachmentsNames}
      />
      <TenantPassportDataModal
        clientId={clientId}
        onCancel={hideTenantPassportData}
        visible={TenantPassportDataVisible}
      />
    </div>
  );
};
